import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { ModelIcon } from './ModelIcon';
import { arsenalItems, calculators, challengeIncludes, challengeRoutes, images } from '../data/kit';
import { getAccent } from '../utils/accent';
export function BonusSection() {
  return <section className="w-full bg-ink py-20 text-white lg:py-28" aria-labelledby="bonos" data-id="element-41" data-mp="1yeb5io0i1esc">
      <div className="mx-auto max-w-6xl px-5" data-id="element-42" data-mp="1aogumbzqq0aq">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center" data-id="element-43" data-mp="1ap8q7mtc7y10">
          <div data-id="element-44" data-mp="15pw1sxmtiiwb">
            <p className="text-lg text-white/70" data-id="element-45" data-mp="15qf97keudow3">Pero no queríamos darte solamente información…</p>
            <h2 id="bonos" className="mt-3 font-display text-4xl font-black leading-tight tracking-tight sm:text-5xl" data-id="element-46" data-mp="1jhsqerpa2any">
              Saber qué hacer es una cosa. <span className="text-cta" data-id="element-47" data-mp="1eo7owpoh6yk0">Hacerlo es otra.</span>
            </h2>
            <p className="mt-5 text-lg text-white/80" data-id="element-48" data-mp="qyn92fnmchey">
              Por eso agregamos tres recursos adicionales diseñados específicamente para ayudarte a ejecutar.
            </p>
          </div>
          <img src={images.bonus} alt="Bonos del kit: Desafío 30 Días, Calculadora de Negocios Online y Arsenal Digital" className="w-full rounded-3xl" data-id="element-49" data-mp="29rtajlfv182u" />
        </div>

        {/* Bono 1 */}
        <BonusBlock number={1} title="Arsenal Digital" subtitle="Herramientas y recursos para empezar" data-id="element-50" data-mp="2ogpsca7pxzgn">
          <p className="text-lg text-white/80" data-id="element-51" data-mp="1qth07wd7ps5o">
            Una guía práctica con más de 30 herramientas y recursos para los tres modelos. Vas a encontrar:
          </p>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-52" data-mp="1vuejkc9yks8r">
            {arsenalItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-53" data-mp="25q84ok1qtu25">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-54" data-mp="25rsyg7g8h8yy" />
                <span className="text-white/90" data-id="element-55" data-mp="3c621ja31q7iy">{item}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-white/70" data-id="element-56" data-mp="3h3trhyk4rjki">
            Para que no pierdas semanas preguntándote: <span className="font-semibold text-white" data-id="element-57" data-mp="1h1u6pwaf1k67">“¿Qué herramienta necesito?”</span>
          </p>
        </BonusBlock>

        {/* Bono 2 */}
        <BonusBlock number={2} title="Desafío 30 Días" subtitle="De la lectura a la acción" featured data-id="element-58" data-mp="1q3tmkl9p2i7k">
          <p className="text-lg text-white/80" data-id="element-59" data-mp="1m2rpob392i8r">
            Este puede ser el recurso más importante del KIT. Porque leer no genera resultados.{' '}
            <span className="font-display font-black text-white" data-id="element-60" data-mp="ydfithveam9m">Ejecutar sí puede generarlos.</span>
          </p>
          <p className="mt-4 text-white/80" data-id="element-61" data-mp="tbq49s8yrqgs">
            Primero completás un test para descubrir cuál de los tres modelos puede encajar mejor con{' '}
            <span className="font-semibold text-white" data-id="element-62" data-mp="12e974ccr2331">
              tu capital + tus habilidades + tu tiempo + tu tolerancia al riesgo
            </span>
            . Después elegís una ruta.
          </p>
          <div className="mt-6 grid gap-3 md:grid-cols-3" data-id="element-63" data-mp="ama3r4xa3y0d">
            {challengeRoutes.map(route => {
            const a = getAccent(route.accent);
            return <div key={route.name} className="rounded-2xl bg-white p-5 text-ink" data-id="element-64" data-mp="5aczj2yxf1yq">
                  <p className={`flex items-center gap-2 font-display font-black ${a.text}`} data-id="element-65" data-mp="3mquvmgyaulus">
                    <ModelIcon accent={route.accent} className="h-4 w-4" data-id="element-66" data-mp="3rpfw8hhgr7jr" />
                    {route.name}
                  </p>
                  <p className="mt-2 text-muted" data-id="element-67" data-mp="jaxiq08r6zsr">{route.goal}</p>
                </div>;
          })}
          </div>
          <p className="mt-6 font-semibold text-white" data-id="element-68" data-mp="o87fk0yh2dqm">Incluye:</p>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-69" data-mp="9aoj0cfjyw8m">
            {challengeIncludes.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-sm" data-id="element-70" data-mp="e9rr65qtxikt">
                <CheckIcon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-71" data-mp="2u0dwal0ly9z7" />
                {item}
              </li>)}
          </ul>
          <p className="mt-6 text-white/70" data-id="element-72" data-mp="3f86ircgqa1mp">
            No vas a terminar preguntándote: <span className="font-semibold text-white" data-id="element-73" data-mp="3fa9co7l04ewp">“¿Y ahora qué hago?”</span>
          </p>
        </BonusBlock>

        {/* Bono 3 */}
        <BonusBlock number={3} title="Calculadora de Negocios Online" subtitle="Los números antes de poner tu plata" data-id="element-74" data-mp="35htupa9pfqbt">
          <p className="text-lg text-white/80" data-id="element-75" data-mp="30kbp9tuwbt8k">
            Porque <span className="font-display font-black text-cta" data-id="element-76" data-mp="21ms7730zz4m">facturar no es ganar.</span> Incluimos un sistema
            para calcular y entender la economía de los tres modelos.
          </p>
          <div className="mt-6 overflow-hidden rounded-2xl border border-white/15" data-id="element-77" data-mp="3o8uu1zeqlnvw">
            <div className="grid divide-y divide-white/15 md:grid-cols-3 md:divide-x md:divide-y-0" data-id="element-78" data-mp="3oaxtfa1s4tda">
              {calculators.map(group => {
              const a = getAccent(group.accent);
              return <div key={group.model} className="p-5" data-id="element-79" data-mp="27uuvosvji6ar">
                    <p className="flex items-center gap-2 font-display font-black" data-id="element-80" data-mp="27ta3vb0m11gl">
                      <span className={`flex h-7 w-7 items-center justify-center rounded-md ${a.bg}`} data-id="element-81" data-mp="ne59sxnqudam">
                        <ModelIcon accent={group.accent} className="h-4 w-4 text-white" data-id="element-82" data-mp="sc6q5atsbyie" />
                      </span>
                      {group.model}
                    </p>
                    <p className="mt-3 text-sm text-white/60" data-id="element-83" data-mp="122i7bz2hc478">Calculá:</p>
                    <ul className="mt-2 space-y-1.5" data-id="element-84" data-mp="170tf8497s4mt">
                      {group.items.map(item => <li key={item} className="flex gap-2 text-white/90" data-id="element-85" data-mp="1b1lpn0ttofko">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-86" data-mp="1g1839bdkbxu0" />
                          {item}
                        </li>)}
                    </ul>
                  </div>;
            })}
            </div>
          </div>
          <p className="mt-6 text-white/80" data-id="element-87" data-mp="3mro50xlcx5my">Además vas a poder comparar los tres modelos con tus propios números.</p>
        </BonusBlock>
      </div>
    </section>;
}
interface BonusBlockProps {
  number: number;
  title: string;
  subtitle: string;
  featured?: boolean;
  children: React.ReactNode;
}
function BonusBlock({
  number,
  title,
  subtitle,
  featured = false,
  children
}: BonusBlockProps) {
  return <article className={`mt-16 grid gap-6 border-t border-white/15 pt-12 lg:grid-cols-[minmax(0,4fr)_minmax(0,8fr)] lg:gap-12 ${featured ? 'lg:mt-20' : ''}`} data-id="element-88" data-mp="3jpjm8qs113h3">
      <div data-id="element-89" data-mp="3to8wpyhlflnb">
        <p className="inline-flex items-center gap-2 rounded-full bg-cta px-3 py-1 font-display text-sm font-extrabold uppercase text-cta-ink" data-id="element-90" data-mp="3tosbx7fuzvxn">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="b9rfbxnesbps" />
          Bono #{number}
        </p>
        <h3 className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-92" data-mp="6bq05nt3swjl">{title}</h3>
        <p className="mt-2 text-lg text-white/70" data-id="element-93" data-mp="l8yyj1gtr0kt">{subtitle}</p>
      </div>
      <div data-id="element-94" data-mp="gaf6cjbn0sk0">{children}</div>
    </article>;
}